import { ref, computed } from "vue";
import { AxiosError } from "axios";
import { YuukyuuKanriService } from "@/service/YuukyuuKanriService";
import { FormUtil } from "@/utils/FormUtil";

/*
 * 今年度付与日数の更新
 */
export function useFuyo() {
  let loading = ref(0)
  let isError = ref(false)

  const yuukyuuSrv = new YuukyuuKanriService();
  // 今年度付与日数の更新
  const fuyoUpdate = async (userId: number, fuyoDays: number, tokubetsuKyuukaDays: number, fuyoDate: string) => {
    loading.value++
    let resultRes = {'result' :false, 'error' : {}};
    const res = await yuukyuuSrv.updateFuyo(userId, fuyoDays, tokubetsuKyuukaDays, fuyoDate).then(res => {
      // success
      resultRes.result = true;
    }).catch(e => {
      // error
      resultRes.result = false;

      const err = e as AxiosError<any>;
      // error メッセージを格納
      FormUtil.setLaravelError(resultRes.error, err);

    }).then(() => {
      /* --- finaly処理 --- */
      // 登録中フラグを解除
      loading.value--
    })

    return resultRes;
  };

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    fuyoUpdate,
    isLoading
  }
}
